import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VRow, VCol } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import DemoSection from '../../components/DemoSection.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosSwitchDemo',
    setup(__props) {
        const switch1 = ref(true);
        const switch2 = ref(true);
        const switch3 = ref(true);
        const switch4 = ref(false);
        const switch5 = ref(true);
        return { __sfc: true, switch1, switch2, switch3, switch4, switch5, VContainer, VRow, VCol, CodePreview, DemoSection };
    }
});
